import React from 'react';
import useModalStore from '../../stores/modalStore';
import useUserStore from "../../stores/userStore";
import { hasPermission } from "../../utils/permissions";
import EventsTable from "../sections/EventsTable";
import LoadingSpinner from "../../LoadingSpinner";
import GenericModal from "./GenericModal";
import {EVENT_TYPE} from "../../domain";
import useSettingsStore from "../../stores/settingsStore";

const EventListModal = () => {
    const modalProps = useModalStore(state => state.modalProps.eventListModal);
    const userId = modalProps?.userId;
    const { userIdToFirstName, employeeEvents } = useUserStore();
    const openModal = useModalStore(state => state.openModal);
    const piiClass = useSettingsStore(s => s.blurPII) ? 'blur-pii' : '';
    const events = employeeEvents[userId];

    if (!hasPermission('view_team_status')) return null;

    return (
        <GenericModal
            name="eventListModal"
            title={<>Events for <span className={piiClass}>{userIdToFirstName[userId] || userId}</span></>}
            modalMaxWidth="max-w-4xl"
            hideButton={true}
            stickyFooter={
                <div className="flex justify-end gap-3">
                    <button
                        onClick={() => useModalStore.getState().closeModal("eventListModal")}
                        className="!px-4 !py-2 !text-sm !font-medium !text-gray-600 !bg-transparent !border !border-gray-200 !rounded-xl hover:!bg-gray-50 !transition-colors"
                    >
                        Close
                    </button>
                    <button
                        onClick={() => {
                            openModal("addEventModal", {
                                startingEventType: EVENT_TYPE.CLOCK_IN,
                                userId: userId,
                                userFirstName: userIdToFirstName[userId],
                                needsReview: !hasPermission('approve_deny_events'),
                                isForgottenEvent: true
                            });
                        }}
                        className="!px-4 !py-2 !text-sm !font-semibold !text-white !bg-indigo-600 hover:!bg-indigo-700 !border-none !rounded-xl !shadow-sm hover:!shadow-md !transition-all"
                    >
                        + Add Event
                    </button>
                </div>
            }
        >
            <div className="overflow-y-auto flex-grow px-2">
                {Array.isArray(events) && events.length > 0 ? (
                    <EventsTable userId={userId} />
                ) : (
                    <div className="flex justify-center items-center flex-col gap-2 py-4">
                        <LoadingSpinner />
                    </div>
                )}
            </div>
        </GenericModal>
    );
};

export default EventListModal;
